import {useState} from 'react';

/** Acknowledges a server-confirmed event without treating a proof as a payment. */
export default function PaymentConfirmationNotice({kind,eventID}:{kind:'payment'|'proof';eventID:string}) {
 const key=`fpt-confirmation:${kind}:${eventID}`;
 const [dismissed,setDismissed]=useState(()=>{try{return sessionStorage.getItem(key)==='dismissed'}catch{return false}});
 if(dismissed)return null;
 return <div className="assistant-notice" role="status">
  <strong>{kind==='payment'?'Paiement effectué avec succès !':'Preuve soumise avec succès !'}</strong>
  <p>{kind==='payment'
   ? 'Votre paiement est enregistré. La suite du traitement, la validation et l’apurement sont pris en charge par l’ONT, sans démarche supplémentaire de votre part pour ce règlement.'
   : 'Votre justificatif a été transmis à l’ONT et est en cours de traitement. Le paiement reste en attente de validation. Vous n’avez aucune démarche supplémentaire à effectuer pour ce dépôt.'}</p>
  <p>Vous pouvez consulter les détails ou poursuivre votre navigation.</p>
  <button type="button" className="btn" onClick={()=>{try{sessionStorage.setItem(key,'dismissed')}catch{}setDismissed(true)}}>Continuer</button>
 </div>;
}
